import React from 'react';
import PropTypes from 'prop-types';
import { MenuList, MenuItem } from '@adsk/alloy-react-menu';
import Overlay from '@adsk/alloy-react-overlay';
import { OpenIcon } from '@adsk/alloy-react-icon';

const ProductsMenu = React.forwardRef(
  (
    {
      style,
      className,
      options,
      width,
      renderItem: MenuItemComponent,
      onClose,
      ...rest
    },
    ref
  ) => (
    <Overlay.Container
      ref={ref}
      className={className}
      style={[{ width }, style]}
      variant={Overlay.VARIANTS.LIGHT}
      {...rest}
    >
      <MenuList>
        {options.map(({ key, label, icon, url }) => {
          const IconComponent = icon;

          return (
            <MenuItemComponent
              key={key}
              as="a"
              renderIcon={() => (
                <IconComponent style={{ marginRight: '8px' }} />
              )}
              href={url}
              target="_blank"
              rel="noreferrer noopener"
              nested={false}
              showSelection={false}
              style={{
                justifyContent: 'flex-start',
                padding: '22px 16px',
                display: 'inline-flex',
                textDecoration: 'none',
                alignItems: 'center',
              }}
              onClick={onClose}
            >
              <span>{label}</span>
              <OpenIcon
                size={20}
                style={{ marginLeft: 'auto', flexShrink: 0 }}
              />
            </MenuItemComponent>
          );
        })}
      </MenuList>
    </Overlay.Container>
  )
);

ProductsMenu.displayName = 'ProductsMenu';

ProductsMenu.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  renderItem: PropTypes.elementType,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

ProductsMenu.defaultProps = {
  className: null,
  onClose: undefined,
  width: 300,
  renderItem: MenuItem,
  style: undefined,
};

export default ProductsMenu;
